import localDb from '@util/localDb';

// 按模块的action, reducer整合体
const FUNDS_BOOK = 'FUNDS_BOOK';

export function saveFundsBook(params) {
  return dispatch => {
    localDb.set(FUNDS_BOOK, params);
    return dispatch({
      type: FUNDS_BOOK,
      data: params,
    });
  };
}

// Reducer
export function fundsBook(state = {}, action) {
  switch (action.type) {
    case FUNDS_BOOK:
      return action.data;
    default:
      return localDb.get(FUNDS_BOOK);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/funds_book.js